import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    gap: 15,
    paddingTop: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  imageCard: {
    width: 220,
    padding: 2,

    '& .MuiCardActions-root': {
      padding: '0'
    },

    '& img': {
      height: 150,
      display: 'block',
      objectFit: 'contain',
      borderRadius: 5
    },

    '& .MuiCardContent-root': {
      padding: 0
    },

    '& .MuiCheckbox-root': {
      padding: 5
    }
  }
}));
